module.exports = __webpack_public_path__ + "img/assassin.840ef758.jpg";